import type { Size } from '../../types/FullProduct'

interface GetHasLastUnits {
	sizes: Size[]
}

export const getHasLastUnits = ({ sizes }: GetHasLastUnits): boolean =>
	sizes.some((size) => size.lastUnits)
